// extracted by mini-css-extract-plugin
module.exports = {"AccreditationItem":"AccreditationItem_AccreditationItem__21dgB"};